import { requst } from '../config'

/* ====================================== 材料计划接口 ===================================================== */

// 获取材料计划
export const getMaterialPlanListDataApi = projectId => {
    const url = `/setting/materialPlan/listAll?projectId=${projectId}`
    return requst.get(url)
}

// 保存数据
export const postMaterialPlanDataApi = activityData => {
    const url = `/setting/materialPlan/save`
    return requst.post(url, activityData)
}

/* ====================================== 设备调拨接口 ===================================================== */

// 获取材料计划
export const getEquipmentTransferListDataApi = projectId => {
    const url = `/equipmentTransfer/list?projectId=${projectId}`
    return requst.get(url)
}

// 新增数据
export const postEquipmentTransferDataApi = activityData => {
    const url = `/equipmentTransfer/save`
    return requst.post(url, activityData)
}

/* ====================================== 人员计划接口 ===================================================== */

// 获取人员计划
export const getPersonnelPlanApi = projectId => {
    const url = `/personnelPlan/get?projectId=${projectId}`
    return requst.get(url)
}

// 保存数据
export const postPersonnelPlanDataApi = activityData => {
    const url = `/personnelPlan/save`
    return requst.post(url, activityData)
}

/* ====================================== 动迁计划接口 ===================================================== */

// 保存数据
export const postMobilisationPlanDataApi = activityData => {
    const url = `/mobilisationPlan/save`
    return requst.post(url, activityData)
}

// 获取动迁
export const getMobilisationPlanDataApi = projectId => {
    const url = `/mobilisationPlan/listAll?projectId=${projectId}`
    return requst.get(url)
}

/* ====================================== 设备计划接口 ===================================================== */

// 获取材料计划
export const getEquipmentPlanListDataApi = projectId => {
    const url = `/equipmentPlan/get?projectId=${projectId}`
    return requst.get(url)
}

// 保存数据
export const postEquipmentPlanDataApi = activityData => {
    const url = `/equipmentPlan/save`
    return requst.post(url, activityData)
}

/* ====================================== 生产计划接口 ===================================================== */

// 获取生产计划
export const getProjectPlanLandNodeApi = projectId => {
    const url = `/projectPlanLandNode/listAll?projectId=${projectId}`
    return requst.get(url)
}

// 保存数据
export const postProjectPlanLandNodeApi = activityData => {
    const url = `/projectPlanLandNode/save`
    return requst.post(url, activityData)
}


/* ====================================== 预算接口 ===================================================== */

// 获取 预算 数据
export const getBudgetQuotationDataApi = projectId => {
    const url = `/budgetQuotation/listAll?projectId=${projectId}`
    return requst.get(url)
}

// 保存数据
export const postBudgetQuotationDataApi = activityData => {
    const url = `/budgetQuotation/save`
    return requst.post(url, activityData)
}
